import { randomiseArray } from "../pages/code/helpers";
import holly from "./holly/holly";
import issy from "./issy/issy";
import leah from "./leah/leah";

let allData = [holly, issy, leah];

// Shuffle the collections
allData = randomiseArray(allData);

export const collectionsData = allData;